import _jsx from "@babel/runtime/helpers/jsx";
var _br, _br2;
import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonToolbar, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'reaxl';

/**
 *  MyATC Quick Save Notification
 *  Displays Max state (25 listings saved in local storage) and
 *  Alerts users every 5th listing is saved to sign in to save their listings permanently
 */

function getNotificationMessage(_ref) {
  let {
    isMaxSaved,
    savedInventoryCount
  } = _ref;
  if (isMaxSaved) {
    return {
      preSaveMsg: 'Thanks for using Autotrader to keep tabs on the vehicles you\'re considering.',
      postSaveMsg: ' is so easy! Plus, you can access your saved cars from any device, keep track of price changes, and more.'
    };
  }
  if (savedInventoryCount === 1) {
    return {
      preSaveMsg: 'This car has been temporarily saved to this device only. ',
      postSaveMsg: ' is so easy! Plus, you can access your saved cars from any device, keep track of price changes, and more.'
    };
  }
  return {
    preSaveMsg: 'These cars have been temporarily saved to this device only. ',
    postSaveMsg: ' is so easy! Plus, you can access your saved cars from any device, keep track of price changes, and more.'
  };
}
function renderModalBody(_ref2) {
  let {
    onSignUpClick,
    isMaxSaved,
    savedInventoryCount
  } = _ref2;
  const {
    preSaveMsg,
    postSaveMsg
  } = getNotificationMessage({
    isMaxSaved,
    savedInventoryCount
  });
  return /*#__PURE__*/_jsx("span", {}, void 0, preSaveMsg, _br || (_br = /*#__PURE__*/_jsx("br", {})), _br2 || (_br2 = /*#__PURE__*/_jsx("br", {})), /*#__PURE__*/_jsx(Button, {
    onClick: onSignUpClick,
    onKeyUp: onSignUpClick,
    bsStyle: "text"
  }, void 0, "Signing up"), postSaveMsg);
}
function renderModalFooter(_ref3) {
  let {
    onHide,
    onSignUpClick
  } = _ref3;
  return /*#__PURE__*/_jsx(ButtonToolbar, {
    className: "pull-right"
  }, void 0, /*#__PURE__*/_jsx(Button, {
    onClick: onHide
  }, void 0, "Close"), /*#__PURE__*/_jsx(Button, {
    bsStyle: "primary",
    onClick: onSignUpClick
  }, void 0, "Sign Me Up"));
}
function renderModalHeading(_ref4) {
  let {
    isMaxSaved,
    savedInventoryCount
  } = _ref4;
  if (isMaxSaved) {
    return 'Save More Cars with a Free Account';
  }
  return savedInventoryCount === 1 ? savedInventoryCount + ' Saved Car' : savedInventoryCount + ' Saved Cars';
}
function QuickSaveNotification(_ref5) {
  let {
    isMaxSaved = false,
    onHide = () => {},
    onSignUpClick = () => {},
    savedInventoryCount = 0,
    show = false,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(Modal, Object.assign({
    bsSize: "small",
    show: show,
    onHide: onHide,
    "data-cmp": "myatc-quickSaveNotification"
  }, rest), /*#__PURE__*/_jsx(ModalHeader, {
    closeButton: true
  }, void 0, /*#__PURE__*/_jsx(ModalTitle, {}, void 0, renderModalHeading({
    isMaxSaved,
    savedInventoryCount
  }))), /*#__PURE__*/_jsx(ModalBody, {}, void 0, renderModalBody({
    onSignUpClick,
    isMaxSaved,
    savedInventoryCount
  })), /*#__PURE__*/_jsx(ModalFooter, {}, void 0, renderModalFooter({
    onHide,
    onSignUpClick
  })));
}
export default QuickSaveNotification;